import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'

const Bar = ({ className, style }: { className: string; style?: CSSProperties }) => (
  <div className={cn('animate-pulse rounded-lg bg-foreground/[0.06]', className)} style={style} />
)

/**
 * Заготовка страницы настроек, пока курс и свежая модерация не приехали (гейт
 * редактора — бывает несколько секунд). Повторяет раскладку `PageBody`: заголовок,
 * вкладки, поля «Основного» — вместо пустого экрана со спиннером.
 */
export const CourseSettingsSkeleton = () => (
  <div
    className="mx-auto w-full max-w-5xl space-y-4 px-4 py-8 xl:max-w-6xl wide:max-w-7xl"
    aria-busy="true"
  >
    <div className="flex items-center gap-3">
      <Bar className="size-9 rounded-full" />
      <Bar className="h-8 w-64 max-w-[60%]" />
    </div>
    <div className="flex gap-3 overflow-hidden border-b border-border pb-3">
      {[96, 80, 128, 120, 72, 72].map((w, i) => (
        <Bar key={i} className="h-5 shrink-0" style={{ width: w }} />
      ))}
    </div>
    <div className="space-y-6 pt-4">
      <div className="space-y-2">
        <Bar className="h-4 w-32" />
        <Bar className="h-11 w-full" />
      </div>
      <div className="space-y-2">
        <Bar className="h-4 w-24" />
        <Bar className="h-28 w-full" />
      </div>
      <div className="space-y-2">
        <Bar className="h-4 w-28" />
        <Bar className="aspect-video w-full max-w-sm" />
      </div>
    </div>
  </div>
)
